/**
 * Simple UUID generator for user identification.
 * Generates a 10-character alphanumeric string.
 * Not cryptographically secure, but sufficient for user tracking.
 */
export function generateSimpleUUID(): string {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789"
    let result = ""
    for (let i = 0; i < 10; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return result
}

/**
 * Get or create user UUID from localStorage.
 * This UUID persists across sessions and identifies the user.
 */
export function getUserUUID(): string {
    const existing = localStorage.getItem("userUUID")
    if (existing) return existing

    const uuid = generateSimpleUUID()
    localStorage.setItem("userUUID", uuid)
    return uuid
}
